import { ChangeDetectorRef, Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { FormEventRegistrationService } from 'src/app/service/form-event-registration.service';
import { LoadingService } from 'src/app/service/loading.service';

@Component({
  selector: 'app-event-button',
  templateUrl: './event-button.component.html',
  styleUrls: ['./event-button.component.scss']
})
export class EventButtonComponent extends FieldType {

  modalOpen: boolean = false;
  selected!: number;

  constructor(
    private loadingService: LoadingService,
    private formEventRegistrationService: FormEventRegistrationService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  //On click self will register the current user in the event. This should make a request to check the event for availability and toggle a flag to change the view
  onClickSelf() {
    this.loadingService.setLoading(true);

    this.formEventRegistrationService
      .registerRegistrant(this.props['uuId'], this.props['sectionId'], { self: 1 })
      .subscribe({
        next: () => {
          this.props['refreshCallback']();
        },
        error: () => {
          this.loadingService.setLoading(false);
        }
      })
  }

  //On click linked will register a linked user in the event. This should make a request to check the event for availability and open a modal to select a linked 
  //profile. Same view toggle should be displayed
  onClickLinked() {
    this.modalOpen = true;
    this.changeDetectorRef.detectChanges();
  }

  //On click guest will register a guest user in the event. This should make a request to check the event for availability and toggle a flag to change the view
  onClickGuest() {
    this.loadingService.setLoading(true);

    this.formEventRegistrationService
      .registerRegistrant(this.props['uuId'], this.props['sectionId'], { guest: 1 })
      .subscribe({
        next: () => {
          this.props['refreshCallback']();
        },
        error: () => {
          this.loadingService.setLoading(false);
        }
      })
  }

  onClose(event: Event): void {

    const target = event.target as HTMLElement;

    if (target.localName === 'sl-select') {
      event.stopPropagation();
    } else {
      this.modalOpen = false;
      this.changeDetectorRef.detectChanges();
    }
  }

  onSelectionChange(event: any) {
    this.selected = event.target.value;
  }

  onAdd(): void {
    this.loadingService.setLoading(true);

    this.formEventRegistrationService
      .registerRegistrant(this.props['uuId'], this.props['sectionId'], { self: 0, guest: 0, userId: this.selected })
      .subscribe({
        next: () => {
          this.props['refreshCallback']();
        },
        error: () => {
          this.loadingService.setLoading(false);
        }
      })
  }
}
